"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _BreakdownScore = _interopRequireDefault(require("./BreakdownScore"));

var _ScoreConstants = _interopRequireDefault(require("../constants/ScoreConstants"));

var BreakdownScoreContainer =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(BreakdownScoreContainer, _React$Component);

  function BreakdownScoreContainer() {
    (0, _classCallCheck2.default)(this, BreakdownScoreContainer);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(BreakdownScoreContainer).apply(this, arguments));
  }

  (0, _createClass2.default)(BreakdownScoreContainer, [{
    key: "render",
    value: function render() {
      var websiteGrade = this.props.websiteGrade;
      var performanceScore = websiteGrade.get('performanceAudit').get('grade');
      var mobileGrade = websiteGrade.get('mobileAudit').get('grade');
      var seoGrade = websiteGrade.get('seoAudit').get('grade');
      var securityGrade = websiteGrade.get('securityAudit').get('grade');
      return _react.default.createElement("div", {
        className: "breakdown-score-container"
      }, _react.default.createElement(_BreakdownScore.default, {
        page: "performance",
        score: performanceScore,
        overallScore: _ScoreConstants.default.PERFORMANCE_OVERALL
      }), _react.default.createElement(_BreakdownScore.default, {
        page: "seo",
        score: seoGrade,
        overallScore: _ScoreConstants.default.SEO_OVERALL
      }), _react.default.createElement(_BreakdownScore.default, {
        page: "mobile",
        score: mobileGrade,
        overallScore: _ScoreConstants.default.MOBILE_OVERALL
      }), _react.default.createElement(_BreakdownScore.default, {
        page: "security",
        score: securityGrade,
        overallScore: _ScoreConstants.default.SECURITY_OVERALL
      }));
    }
  }]);
  return BreakdownScoreContainer;
}(_react.default.Component);

exports.default = BreakdownScoreContainer;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/BreakdownScoreContainer.js
// module id = 310
// module chunks = 0